/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */

export enum LoginTypes {
  SIGN_IN_REQUEST = "@LOGIN/SIGN_IN_REQUEST",
  SIGN_IN_SUCCCES = "@login/SIGN_IN_SUCCCES",
  SIGN_IN_FAILURE = "@login/SIGN_IN_FAILURE",
  LOGOUT = "@login/LOGOUT",
}

export interface EmpresaVendasProps {
  readonly id: string | null;
  readonly nome: string | null;
}

export interface EmpreendimentoPDVProps {
  readonly id: string | null;
  readonly nome: string | null;
}

interface PlantaoVendasProps {
  readonly id: string | null;
  readonly nome: string | null;
  readonly empreendimentoPDV: EmpreendimentoPDVProps | null;
}
export interface AuthState {
  readonly idAD: string | null;
  readonly userId: string;
  readonly name: string;
  readonly apelido: string | null;
  readonly username: string;
  readonly urlFoto: string;
  readonly siglaNome: string;
  readonly termosCondicoesRealizacaoAgendamentosAceito: boolean;
  readonly termosClubeVantagensPolePositionAceito: boolean;
  readonly deviceId: string | null;
  readonly codigoRegional365: string;
  readonly idRegional: string;
  readonly idRegionalSistemaOrigem: string;
  readonly idCorretorSistemaOrigem: string;
  readonly idCorretor2013: string;
  readonly usuarioVivaz: boolean;
  readonly usuarioBackofficeVivaz: boolean;
  readonly usuarioComercial: boolean;
  readonly usuarioCia: boolean;
  readonly usuarioDiretor: boolean;
  readonly usuarioGerenteOnline: boolean;
  readonly permissoes: Array<string>;
  readonly empresaVendas: EmpresaVendasProps[] | null;
  readonly idsBandeiras: string[];
  readonly consumerApi: number | null;
  readonly idPerfilAcesso365: string | null;
  readonly idEmpresaVendas365: string | null;
  readonly codigoEmpresaVendas365: string | null;
  readonly plantaoVendas: PlantaoVendasProps | null | undefined;
  readonly acessoAppFase1: string | null;
  readonly acessoAppFase2: string | null;
  readonly acessoAdmin: string | null;
  readonly acessoMobile: string | null;
  readonly acessoAppWeb: string | null;
  readonly idEquipeCargo: string | null;
  readonly idCorretorBolsao365: string | null;
  readonly idCargo: string | null;
  readonly idCargo2013: string | null;
  readonly codigoCargo2013: string | null;
  readonly token: string;
  readonly isError: boolean;
  readonly signed: boolean;
  readonly loading: boolean;
  readonly dataNascimento: string;
  readonly dataVencimentoCreci: string;
  readonly fazAniversarioHoje: boolean;
  readonly creciVencido: boolean;
  readonly supervisorProduto: boolean;
  readonly possuiToken3cplus: boolean;
  readonly linkToken3cplus: string;
}

export const SET_USER = "SET_USER";
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE";
export const SET_IS_ERROR = "SET_IS_ERROR";
export const SET_LOADING_LOGIN = "SET_LOADING_LOGIN";
export const SET_CLEAN_USER = "SET_CLEAN_USER";

interface SetUser {
  type: typeof SET_USER;
  payload: AuthState;
}

interface SetCleanUser {
  type: typeof SET_CLEAN_USER;
}

interface SetLoadingLogin {
  type: typeof SET_LOADING_LOGIN;
  payload: boolean;
}

interface SetLoginErrorMessageLogin {
  type: typeof SET_ERROR_MESSAGE;
  payload: string;
}
interface SetLoginIsErrorMessageLogin {
  type: typeof SET_IS_ERROR;
  payload: boolean;
}

export type UserActionTypes =
  | SetUser
  | SetLoginErrorMessageLogin
  | SetLoginIsErrorMessageLogin
  | SetLoadingLogin
  | SetCleanUser;
